import TriStorage from '@tri-admin/utils/src/storage'

export default new TriStorage('WSP')
